import React from 'react'
import { useNavigate } from 'react-router-dom'

const HeaderReturn = ({ title, image, link }) => {
    let navigate = useNavigate() 
 
    return (
        <div className='row'>
            <div style={{ top: "0px", position: "fixed", width: "100%", backgroundColor:'white' }}>
                <div className='row pb-2 shadow' onClick={() => navigate( link )} style={{ height:'4rem' }}>
                    <div className='col-3 align-self-center'>
                        <i className="bi bi-arrow-left" style={{ fontSize:'1.8rem' }}></i>
                    </div>
                    <div className='col-6 align-self-center text-center h5'>{title}</div>
                    <div className='col-3 align-self-center text-center'>
                        {image && <img src={image} alt='image du logo' style={{ height:35, width:35 }} />}
                    </div>
                </div>
            </div>
            <div style={{ height:'4rem'}}/>
        </div>
    )
}

export default HeaderReturn


/*

                    <div className='col-1 text-start align-self-center'>
                        <span>
                            <i className="bi bi-arrow-left" style={{ fontSize:'1.8rem' }}></i>
                        </span> 
                    </div>
                    <div className='col-10 text-center h5 text-center align-self-center'>{title}</div>
                    <div className='col-1 text-start align-self-center'>
                        {image &&
                            <img src={image} className='img-fluid me-2' alt='image du logo' style={{ height:40, width:40 }} />
                        }
                    </div>

*/